import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { Store } from '@ngrx/store';
import { filter, map, take, tap } from 'rxjs/operators';
import { UserAuthActions } from '../../store/user/auth/user-auth.actions';
import { selectUserAuthState } from '../../store/user/auth/user-auth.selectors';
import { firstAllowedAppRoute } from '../constants/app-config.constants';

/** Sends the caller to the first sidebar page their privileges allow, or Forbidden. */
export const landingGuard: CanActivateFn = () => {
  const store = inject(Store);
  const router = inject(Router);

  return store.select(selectUserAuthState).pipe(
    tap((state) => {
      if (!state.isLoading && !state.userDetails && !state.error) {
        store.dispatch(UserAuthActions.loadUserDetails());
      }
    }),
    filter((state) => !state.isLoading && (!!state.userDetails || !!state.error)),
    take(1),
    map((state) => {
      const privileges = (state.userDetails?.privileges ?? []) as string[];
      return router.parseUrl(firstAllowedAppRoute(privileges));
    })
  );
};
